import ExportPanel from './ExportPanel';
import ImportPanel from './ImportPanel';
import QaAllowlistPanel from './QaAllowlistPanel';

const ExportImportProgress = () => (
  <div className="d-flex flex-column">
    <style>{`
      .dimmed-placeholder::placeholder {
        color: #adb5bd;
        font-style: italic;
        opacity: 1;
      }
    `}</style>
    <QaAllowlistPanel />
    <ExportPanel />
    <ImportPanel />
  </div>
);

export default ExportImportProgress;
